import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    width: 100%;
    justify-content: start;
    font-family: 'Proxima Nova Bold', Arial, Helvetica, sans-serif;
    font-size: 20px;
    color: ${colors.prussian};
    padding-top: 8px;
    padding-bottom: 8px;
  `,
};

export default styles;
